import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const subscriptionCanceledV1Schema = eventEnvelopeSchema.extend({
  previousPlan: z.string().min(1).max(128).optional(),
  stripeSubscriptionId: z.string().min(1).max(256).optional(),
  canceledAt: z.string().datetime({ offset: true }).optional(),
});

export type SubscriptionCanceledV1 = z.infer<typeof subscriptionCanceledV1Schema>;

export const SUBSCRIPTION_CANCELED_V1_DETAIL_TYPE =
  'subscription.canceled.v1' as const;
